<template>
  <div v-if="game" class="game-view">
    <router-link :to="{ name: 'games' }">
      <div class="back-to-list">
        <img :src="require('@/assets/games/back-arrow.png')" alt="">
        <span>Back</span>
      </div>
    </router-link>
    <div class="game-view-image">
      <img
        :src="`https://s3.amazonaws.com/images.growmindgrow/previews/${game.preview}`"
        alt
      />
      <router-link
        v-if="!game.isPremium || (game.isPremium && parentAccountData.premium_access)"
        class="play-link"
        :to="{ name: 'game', params: { id: game.id } }"
      >
        <img :src="require('@/assets/games/play-button.png')" alt="">
      </router-link>
    </div>
    <div class="game-view-description">
      <p>{{ game.name }}</p>
      <span>{{ game.description }}</span>
    </div>
    <div class="game-view-labels">
      <div class="premium">
        <img :src="require('@/assets/games/premium-game-icon.png')" alt="">
        <span>Premium Game</span>
      </div>
      <div class="category">
        <category-icon :category="game.category" />
        <span>{{ game.category }}</span>
      </div>
      <div class="grade" v-if="grade">
        <grade-icon :game="game" style="font-size: 14px;"  />
        <span>{{ grade }} Grade Level</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CategoryIcon from '@/components/icons/CategoryIcon';
import GradeIcon from '@/components/icons/GradeIcon';

export default {
  name: 'GameView',
  components: { CategoryIcon, GradeIcon },
  computed: {
    ...mapGetters({
      parentAccount: 'parent/parentAccount',
      getGameById: 'games/getGameById',
    }),
    parentAccountData() {
      return this.parentAccount || {};
    },
    gameId() {
      return this.$route.params.id;
    },
    game() {
      return this.getGameById(this.gameId);
    },
    minGrade() {
      let result = null;
      if (this.game.difficulties && this.game.difficulties.length) {
        // eslint-disable-next-line max-len
        let grade = this.game.difficulties.reduce((min, config) => (config.grade < min ? config.grade : min), this.game.difficulties[0].grade);
        grade = grade === -1 ? 'Pre-K' : grade;
        grade = grade === 0 ? 'K' : grade;
        result = grade;
      }
      return result;
    },
    maxGrade() {
      let result = null;
      if (this.game.difficulties && this.game.difficulties.length) {
        // eslint-disable-next-line max-len
        let grade = this.game.difficulties.reduce((max, config) => (config.grade > max ? config.grade : max), this.game.difficulties[0].grade);
        grade = grade === -1 ? 'Pre-K' : grade;
        grade = grade === 0 ? 'K' : grade;
        result = grade;
      }
      return result;
    },
    grade() {
      return this.minGrade === this.maxGrade ? this.minGrade : `${this.minGrade}-${this.maxGrade}`;
    },
  },
  created() {
    if (!this.game) {
      this.fetchGameById(this.gameId);
    }
  },
  methods: {
    ...mapActions('games', [
      'fetchGameById',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

a {
  text-decoration: none;
}

.game-view {
  /*background: #E5E5E5;*/
  padding-top: 36px;
  min-height: 100vh;
  padding-left: 65px;

  @include for-size(phone-only) {
    padding-left: 0;
  }

  .back-to-list {
    max-width: 586px;
    width: 90%;
    height: 40px;
    color: #7B7B7B;
    background: #FFFFFF;
    box-shadow: -2px -2px 2px rgba(0, 0, 0, 0.05), 2px 2px 2px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin: 16px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
      height: 12px;
      position: absolute;
      left: 16px;
    }
    span {
      font-size: 18px;
    }
  }

  &-image {
    width: 100%;
    position: relative;

    img {
      width: 100%;
    }

    .play-link {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-width: 120px;
      width: 25%;

      img {
        width: 100%;
      }
    }
  }

  &-description {
    padding: 8px 16px;
    background: #fff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);

    p {
      font-size: 20px;
      margin-bottom: 8px;
    }

    span {
      font-size: 16px;
    }
  }

  &-labels {
    padding: 20px 40px;
    color: #000;
    & > div {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin: 16px 0;

      span {
        margin-left: 10px;

        &::first-letter {
          text-transform: uppercase;
        }
      }
    }

  }
}
</style>
